import translate from 'app/translations';

export const SERVICE_ERROR_NOTIFICATION = 'SERVICE_ERROR_NOTIFICATION';
export const SERVICE_SUCCESS_NOTIFICATION = 'SERVICE_SUCCESS_NOTIFICATION';

export const setServiceSuccessNotification = (successMessage, id) => ({
  type: SERVICE_SUCCESS_NOTIFICATION,
  payload: { message: successMessage || translate('Generic.operationSuccess'), id },
});

export const setServiceErrorNotification = (errorMessage, id) => ({
  type: SERVICE_ERROR_NOTIFICATION,
  payload: { message: errorMessage || translate('Generic.operationError'), id },
});
